module.exports = __webpack_public_path__ + "NandhiniR-c8ae5415.webp";